import { UserManager } from 'oidc-client-ts';
import { oidcAuthConfig } from './oidcAuthConfig';
import { PATHS } from '@/utils/paths';
import { getUiBasePathPrefix } from '@/utils/basePath';

// Single UserManager instance shared across the entire app: react-oidc-context's
// AuthProvider AND the imperative getAuthToken path used by API call interceptors.
// Multiple UserManager instances each schedule their own automaticSilentRenew timer,
// all firing simultaneously when the access token nears expiry. The resulting
// parallel POST /token requests exceed Ory Fosite's rotation_grace_reuse_count
// cap, fork the refresh-token chain, and break subsequent rotation cycles.
export const oidcUserManager = new UserManager(oidcAuthConfig);

// Defense in depth: if silent renewal fails terminally (refresh token expired
// at 24h absolute lifetime, refresh token revoked, IDP downtime, etc.), redirect
// the user to signin so they don't sit on a broken page with a console retry
// loop. Without this handler, oidc-client-ts fires silentRenewError but the UI
// stays put with a dead access token; every subsequent API call returns 403.
oidcUserManager.events.addSilentRenewError(error => {
  console.warn('OIDC silent renewal failed; redirecting to signin', error);
  oidcUserManager.removeUser().catch(() => {});
  const prefix = getUiBasePathPrefix();
  const signInPath = `${prefix}${PATHS.SIGN_IN}`;
  if (!globalThis.location.pathname.startsWith(signInPath)) {
    globalThis.location.assign(signInPath);
  }
});
